import { SharedFunnelService } from './../../../../funnel/shared-funnel.service';
import { SharedPortalService } from './../../../shared-portal.service';
import { SharedOfferService } from './../../../../offer/shared-offer.service';
import {
  SharedPortalViewService,
  PortalViewPageStatusEnum,
} from './../../shared-portal-view.service';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { WebsiteModel } from '../../../portal.model';
import {
  selectWebsite,
  isWebsiteLoaded,
} from 'src/app/shared/store/_features/website/website.selector';
import { Store } from '@ngrx/store';
import { DynamicActionButtonItem } from 'src/app/shared/models/dynamic-buttons.model';

@Component({
  selector: 'app-portal-view-head-title-add',
  templateUrl: './portal-view-head-title-add.component.html',
  styleUrls: ['./portal-view-head-title-add.component.css'],
})
export class PortalViewHeadTitleAddComponent implements OnInit {
  @Input() minimalForScroll: boolean = false;

  websitePreviewButton: DynamicActionButtonItem;
  website$: Observable<WebsiteModel>;
  websiteLoaded$: Observable<boolean>;

  website: WebsiteModel;
  showDetails: boolean = true;
  portalViewPageStatusEnum = PortalViewPageStatusEnum;
  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    public sharedPortalService: SharedPortalService,
    public sharedOfferService: SharedOfferService,
    public sharedFunnelService: SharedFunnelService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {
    this.website$ = this.store.select(selectWebsite);
    this.website$.subscribe((value) => {
      this.website = value;
      this.websitePreviewButton = {
        label: 'Preview Website',
        colorSet: 'light-primary',
        colorSetHover: 'light-primary',
        hiddenButton: false,

        buttonSize: 'sm',
        action: () => {
          window.open(`http://${value.siteUrl}`, '_blank');
        },
        iconSvg: 'assets/images/svg/system/preview.svg',
      };
    });
    this.websiteLoaded$ = this.store.select(isWebsiteLoaded);
  }

  ngOnInit(): void {}

  async reloadPortalOffers() {
    // await this.sharedPortalViewService.reloadPortalOffers();
  }
}
